import { IFeaturedItem } from '../models/featurered-item';
import { IResult } from '../models/result-models';
import { apiGet } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/featured-items';

export const getFeaturedItems = async (): Promise<IResult<IFeaturedItem[]>> => {
    const result = await apiGet<IFeaturedItem[]>(baseUrl);
    return result;
};
